<div class="main">
  <h2 class="modalTitle">
    {{ 'infoAndConditions' | i18next }}
  </h2>

  <div class="main--dialogContent">
    <div
      *ngIf="data.info && data.info.trim().length > 0"
      [innerHTML]="data.info"
      class="campaign-info"
    ></div>
    <div
      *ngIf="!data.info || data.info.trim().length === 0"
      class="no-info-message"
    >
      <p>{{ 'noCampaignInfo' | i18next }}</p>
    </div>
  </div>

  <div class="modalBtnContainer">
    <button class="modalBtnContainer__btn" (click)="close()">
      {{ 'btnClose' | i18next | uppercase }}
    </button>
  </div>
</div>
